import React from 'react'

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';



const useStyles = makeStyles({
    root: {
        maxWidth: 250,
    },
    media: {
        height: 200,
    },
});
const Learncard=(props)=>{
    const classes = useStyles();

    const onclicklearn=()=>{
        
        props.setcoruse(props.title);
        
        props.setmodelstate(true);
            }
   

    return(

<Card className={classes.root}>
    <CardActionArea>
        <CardMedia
            className={classes.media}
            image={props.image}
            title="Contemplative Reptile"
        />
        <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
               {props.title}
</Typography>
            <Typography variant="body2" color="textSecondary" component="p">
             {props.content}
</Typography>
        </CardContent>
    </CardActionArea>
    <CardActions>
    
        <Button size="small" color="primary" variant="contained" onClick={onclicklearn}>
            Learn 
</Button>
    </CardActions>
</Card>
    )
}

export default Learncard